<div class="app-wrapper" *ngIf="status == STATUS_DONE else approvalsLoading">
  <ng-container *ngIf="feedbacksAccess && globalApprovalsAccess !== false; else forbiddenFeedbacks">
    <nav class="tab_navigation">
      <!-- approvals status  menu  completed/outstanding-->
      <app-approvals-status-menu-main *ngIf="approvalsStatusMenu.length > 1" [status]="approvalsStatusMenu"></app-approvals-status-menu-main>
    </nav>
    <section class="main-content approvals-section">
      <div class="app-main">
        <!-- approvals-search -->
        <div class="approvals-section-nav">
          <!-- empty by now -->
        </div>
        <approvals-search-main></approvals-search-main>
        <!-- TODO: here will load approvasl results screen -->
        <approvals-results-main [params]="params" [itemsList]="currentItems"></approvals-results-main>
      </div>
    </section>
  </ng-container>
  <ng-template #forbiddenFeedbacks>
    <section class="main-content approvals-section-forbidden">
      <core-helpers-box-alert-message-icon
            [text]="'You don\&apos;t have permission to see approvals.'"
            [icon]="'alert'"
        ></core-helpers-box-alert-message-icon>
    </section>
  </ng-template> 
</div>

<ng-template #approvalsLoading>
  <div class="loader approv-section" >
    <div class="dimmed_outset">
          <core-title-section [title]="'APPROVALS'"></core-title-section>
          <div class="dimmed_search ">
          <app-helpers-search-bar-main [placeholder]="'Search the approvals'" [term]="''" [filters]="">
          </app-helpers-search-bar-main>
          </div>
    </div>
    <div class="dimmed dimmed_main" >
        <div class="dimmed_nav">
          <div class="dimmed_subtitle"></div>
          <div class="dimmed_subtitle"></div>
          <div class="dimmed_subtitle"></div>
          <div class="dimmed_subtitle"></div>
          <div class="dimmed_subtitle"></div>
          <div class="dimmed_subtitle"></div>
          <div class="dimmed_subtitle"></div>
        </div>

    </div>
  </div>
</ng-template>
